import React from 'react';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import AccueilSection from './AccueilSection';
import PsychomotriciteSection from './PsychomotriciteSection';
import EquipeSection from './EquipeSection';
import LiensSection from './LiensSection';
import GalerieSection from './GalerieSection';

interface MainContentProps {
  isVisible: boolean;
  currentSection: string;
}

const Container = styled.div<{ $isVisible: boolean }>`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 40px;
  color: var(--color-text);
  position: relative;
  z-index: 1;
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
  min-height: calc(100vh - 70px);
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

const MainContent = ({ isVisible, currentSection }: MainContentProps) => {
  return (
    <Container $isVisible={isVisible}>
      <ContentWrapper>
        <AnimatePresence mode="wait">
          {currentSection === 'accueil' && <AccueilSection key="accueil" />}
          {currentSection === 'psychomotricite' && <PsychomotriciteSection key="psychomotricite" />}
          {currentSection === 'galerie' && <GalerieSection key="galerie" />}
          {currentSection === 'equipe' && <EquipeSection key="equipe" />}
          {currentSection === 'liens' && <LiensSection key="liens" />}
        </AnimatePresence>
      </ContentWrapper>
    </Container>
  );
};

export default MainContent;
